<page-header title="PROFILE"></page-header>
<card>
  <div class="columns">
    <div class="column">
      <h5 style="margin-bottom: 30px">{{ 'User info' | translate }}</h5>
      <ul>
        <li translationEditableDirective="FIRST_NAME">
          {{ 'FIRST_NAME' | translate }}: {{ profile.firstName }}
        </li>
        <li translationEditableDirective="LAST_NAME">
          {{ 'LAST_NAME' | translate }}: {{ profile.lastName }}
        </li>
        <li translationEditableDirective="EMAIL">
          {{ 'EMAIL' | translate }}: {{ profile.email }}
        </li>
      </ul>
    </div>
    <div class="column">
      <h5
        style="margin-bottom: 30px"
        translationEditableDirective="CHANGE_PASSWORD"
      >
        {{ 'CHANGE_PASSWORD' | translate }}
      </h5>
      <form class="form mx-0 mb-0" (submit)="onSubmit($event)">
        <div class="field is-narrow">
          <label
            class="label"
            translationEditableDirective="EXISTING_PASSWORD"
            >{{ 'EXISTING_PASSWORD' | translate }}</label
          >
          <div class="control">
            <input
              class="input is-small"
              name="existingPassword"
              type="password"
              (input)="handleFieldChange($event)"
              [value]="getField(['existingPassword'])"
              [ngClass]="{ 'is-danger': hasError('existingPassword') }"
            />
          </div>
          <p class="help is-danger" *ngIf="hasError('existingPassword')">
            {{ getError('existingPassword') }}
          </p>
        </div>

        <div class="field is-narrow">
          <label class="label" translationEditableDirective="NEW_PASSWORD">{{
            'NEW_PASSWORD' | translate
          }}</label>
          <div class="control">
            <input
              class="input is-small"
              name="newPassword"
              type="password"
              (input)="handleFieldChange($event)"
              [value]="getField(['newPassword'])"
              [ngClass]="{ 'is-danger': hasError('newPassword') }"
            />
          </div>
          <p class="help is-danger" *ngIf="hasError('newPassword')">
            {{ getError('newPassword') }}
          </p>
        </div>

        <div class="field is-grouped">
          <div class="control">
            <button
              [disabled]="isUpdating"
              type="submit"
              class="button is-link"
              translationEditableDirective="SUBMIT"
            >
              {{ 'SUBMIT' | translate }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</card>
